import type { RouteRecordRaw, NavigationGuardNext, RouteLocationNormalized } from 'vue-router'
import { useMeStore } from '@/stores/me'

const requireAuth = (
    to: RouteLocationNormalized,
    from: RouteLocationNormalized,
    next: NavigationGuardNext,
) => {
    const meStore = useMeStore()

    meStore.restoreSession()

    if (meStore.isAuthenticated) {
        next()
    } else {
        next({ name: 'investors-login' })
    }
}
export const ipbFormRoutes: RouteRecordRaw[] = [
    {
        name: 'investors-ipbForms-edit',
        path: '/investors/ipb-forms/:formId/edit',
        component: () => import('./[formId].vue'),
        beforeEnter: requireAuth,
        props: true,
    },
    {
        name: 'investors-ipbForms-new',
        path: '/investors/ipb-forms/new',
        component: () => import('./new.vue'),
        beforeEnter: requireAuth,
    },
]
